import { ExternalLink } from "lucide-react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import IgMobileDialog from "@intelligems/ig-theme/mobile/IgMobileDialog";
import { ExperienceFe } from "@intelligems/ig-types/fe-only/experiences";
import { Box } from "@mui/material";
import { endShippingTest } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

interface MobileEndTestModalProps {
  open: boolean;
  onClose: () => void;
  onEnd: () => void;
  experience: ExperienceFe;
  loading?: boolean;
}

export const MobileEndTestModal = ({
  open,
  onClose,
  onEnd,
  experience,
  loading = false,
}: MobileEndTestModalProps) => {
  const isShippingTest = experience.testTypes?.hasTestShipping ?? false;

  return (
    <IgMobileDialog
      open={open}
      onClose={onClose}
      title="End Test"
      yesButtonText="End Test"
      handleYesClick={onEnd}
      yesButtonColor="error"
      loading={loading}
    >
      {isShippingTest ? (
        <>
          <IgTypography>Are you sure you want to end this test?</IgTypography>

          <IgTypography>
            <span style={{ fontWeight: 600 }}>Important:</span> Once ended,
            shipping rates will be returned back to normal. If you'd like to
            change them based on the results of the test, make sure to update
            them in Shopify.
          </IgTypography>

          <Box>
            <IgTypography
              variant="caption"
              sx={{
                color: "primary.main",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => openNewTab(endShippingTest)}
            >
              Learn more about ending shipping tests{" "}
              <ExternalLink
                size={12}
                style={{ display: "inline", verticalAlign: "middle" }}
              />
            </IgTypography>
          </Box>
        </>
      ) : (
        <IgTypography>
          Are you sure you want to end this test? Once ended, the test cannot be
          restarted.
        </IgTypography>
      )}
    </IgMobileDialog>
  );
};
